export default __webpack_public_path__ + "images/QM.5585241.png";